module.exports = __webpack_public_path__ + "exo-latin-700.68cc7fa1f6a3184d73c2.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-700.svg
// module id = ../../../../typeface-exo/files/exo-latin-700.svg
// module chunks = styles